import {
  Divider,
  Grid,
  Typography,
  Button,
  Checkbox,
  FormControlLabel,
  Box,
} from "@mui/material";
import { FieldArray } from "formik";
import InputField from "../elements/InputField";

const QuestionTypeSection = ({
  values,
  handleChange,
  handleBlur,
  setFieldValue,
}) => {
  return (
    <>
      {/* --- Single Choice --- */}
      {values.questionType === "single_choice" && (
        <>
          <Grid item xs={12}>
            <Divider />
            <Typography variant="h6">Single Choice Options</Typography>
          </Grid>
          <FieldArray name="options">
            {({ push, remove }) => (
              <>
                {values.options.map((option, index) => (
                  <Grid item xs={12} key={index}>
                    <Box sx={{ mb: 2 }}>
                      <InputField
                        fullWidth
                        label="Option Heading"
                        name={`options.${index}.heading`}
                        value={option.heading}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        required
                        sx={{
                          width: "100%",
                          mb: 2,
                          "& .MuiInputBase-root": {
                            fontSize: "1rem",
                          },
                        }}
                      />
                      <InputField
                        fullWidth
                        label="Option Subtitle"
                        name={`options.${index}.subtitle`}
                        value={option.subtitle}
                        rows={2}
                        multiline
                        onChange={handleChange}
                        onBlur={handleBlur}
                        sx={{
                          width: "100%",
                          mb: 2,
                          "& .MuiInputBase-root": {
                            fontSize: "1rem",
                          },
                        }}
                      />
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={option.default}
                              name={`options.${index}.default`}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  values.options.forEach((_, i) => {
                                    if (i !== index) {
                                      setFieldValue(
                                        `options.${i}.default`,
                                        false
                                      );
                                    }
                                  });
                                }
                                handleChange(e);
                              }}
                            />
                          }
                          label="Default"
                        />
                        <Button
                          variant="text"
                          color="error"
                          onClick={() => remove(index)}
                        >
                          Remove
                        </Button>
                      </Box>
                    </Box>
                  </Grid>
                ))}
                {values.options.length < 6 && (
                  <Grid item xs={12}>
                    <Button
                      variant="outlined"
                      onClick={() =>
                        push({
                          heading: "",
                          subtitle: "",
                          default: false,
                        })
                      }
                    >
                      Add Option
                    </Button>
                  </Grid>
                )}
              </>
            )}
          </FieldArray>
        </>
      )}

      {/* --- Choice with Other --- */}
      {values.questionType === "choice_with_other" && (
        <>
          <Grid item xs={12}>
            <Divider />
            <Typography variant="h6">Choice with Other</Typography>
          </Grid>
          <FieldArray name="options">
            {({ push, remove }) => (
              <>
                {values.options.map((option, index) => (
                  <Grid item xs={12} key={index}>
                    <Box sx={{ mb: 2 }}>
                      <InputField
                        fullWidth
                        label="Option Heading"
                        name={`options.${index}.heading`}
                        value={option.heading}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        required
                        sx={{
                          width: "100%",
                          mb: 2,
                          "& .MuiInputBase-root": {
                            fontSize: "1rem",
                          },
                        }}
                      />
                      <InputField
                        fullWidth
                        label="Option Subtitle"
                        name={`options.${index}.subtitle`}
                        value={option.subtitle}
                        onChange={handleChange}
                        onBlur={handleBlur}
                        sx={{
                          width: "100%",
                          mb: 2,
                          "& .MuiInputBase-root": {
                            fontSize: "1rem",
                          },
                        }}
                      />
                      <Box
                        sx={{ display: "flex", alignItems: "center", gap: 1 }}
                      >
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={option.default}
                              name={`options.${index}.default`}
                              onChange={(e) => {
                                if (e.target.checked) {
                                  values.options.forEach((_, i) => {
                                    if (i !== index) {
                                      setFieldValue(
                                        `options.${i}.default`,
                                        false
                                      );
                                    }
                                  });
                                }
                                handleChange(e);
                              }}
                            />
                          }
                          label="Default"
                        />
                        <Button
                          variant="text"
                          color="error"
                          onClick={() => remove(index)}
                        >
                          Remove
                        </Button>
                      </Box>
                    </Box>
                  </Grid>
                ))}
                {values.options.length < 6 && (
                  <Grid item xs={12}>
                    <Button
                      variant="outlined"
                      onClick={() =>
                        push({
                          heading: "",
                          subtitle: "",
                          default: false,
                        })
                      }
                    >
                      Add Option
                    </Button>
                  </Grid>
                )}
              </>
            )}
          </FieldArray>

          {/* Extra textbox */}
          <Grid item xs={12}>
            <Divider />
            <Typography variant="h6">Other Option Textbox</Typography>
          </Grid>
          <Grid item xs={12}>
            <InputField
              fullWidth
              label="Label"
              name="textfieldConfig.label"
              value={values.textfieldConfig.label}
              onChange={handleChange}
              onBlur={handleBlur}
              required
              sx={{
                width: "100%",
                "& .MuiInputBase-root": {
                  fontSize: "1rem",
                },
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <InputField
              fullWidth
              label="Placeholder"
              name="textfieldConfig.placeholder"
              value={values.textfieldConfig.placeholder}
              rows={2}
              multiline
              onChange={(e) => {
                if (e.target.value.split(" ").length <= 200) {
                  handleChange(e);
                }
              }}
              onBlur={handleBlur}
              sx={{
                width: "100%",
                "& .MuiInputBase-root": {
                  fontSize: "1rem",
                },
              }}
            />
          </Grid>
        </>
      )}

      {/* --- URL Input --- */}
      {values.questionType === "url_input" && (
        <>
          <Grid item xs={12}>
            <Divider />
            <Typography variant="h6">URL Input</Typography>
          </Grid>
          <Grid item xs={12}>
            <InputField
              fullWidth
              label="Label"
              name="textfieldConfig.label"
              value={values.textfieldConfig.label}
              onChange={handleChange}
              onBlur={handleBlur}
              required
              sx={{
                width: "100%",
                "& .MuiInputBase-root": {
                  fontSize: "1rem",
                },
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <InputField
              fullWidth
              label="Placeholder"
              name="textfieldConfig.placeholder"
              value={values.textfieldConfig.placeholder}
              rows={2}
              multiline
              placeholder="http://"
              onChange={(e) => {
                if (e.target.value.split(" ").length <= 200) {
                  handleChange(e);
                }
              }}
              onBlur={handleBlur}
              sx={{
                width: "100%",
                "& .MuiInputBase-root": {
                  fontSize: "1rem",
                },
              }}
            />
          </Grid>
        </>
      )}

      {/* --- Single-line textbox --- */}
      {values.questionType === "single_line_textbox" && (
        <>
          <Grid item xs={12}>
            <Divider />
            <Typography variant="h6">Single-line Textbox</Typography>
          </Grid>
          <Grid item xs={12}>
            <InputField
              fullWidth
              label="Label"
              name="textfieldConfig.label"
              value={values.textfieldConfig.label}
              onChange={handleChange}
              onBlur={handleBlur}
              required
              sx={{
                width: "100%",
                "& .MuiInputBase-root": {
                  fontSize: "1rem",
                },
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <InputField
              fullWidth
              label="Placeholder"
              name="textfieldConfig.placeholder"
              value={values.textfieldConfig.placeholder}
              rows={2}
              multiline
              onChange={(e) => {
                if (e.target.value.split(" ").length <= 200) {
                  handleChange(e);
                }
              }}
              onBlur={handleBlur}
              sx={{
                width: "100%",
                "& .MuiInputBase-root": {
                  fontSize: "1rem",
                },
              }}
            />
          </Grid>
        </>
      )}

      {/* --- Multi-line textbox --- */}
      {values.questionType === "multi_line_textbox" && (
        <>
          <Grid item xs={12}>
            <Divider />
            <Typography variant="h6">Multi-line Textbox</Typography>
          </Grid>
          <Grid item xs={12}>
            <InputField
              fullWidth
              label="Label"
              name="textfieldConfig.label"
              value={values.textfieldConfig.label}
              onChange={handleChange}
              onBlur={handleBlur}
              required
              sx={{
                width: "100%",
                "& .MuiInputBase-root": {
                  fontSize: "1rem",
                },
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <InputField
              fullWidth
              label="Placeholder"
              name="textfieldConfig.placeholder"
              value={values.textfieldConfig.placeholder}
              rows={6}
              multiline
              onChange={(e) => {
                if (e.target.value.split(" ").length <= 200) {
                  handleChange(e);
                }
              }}
              onBlur={handleBlur}
              sx={{
                width: "100%",
                "& .MuiInputBase-root": {
                  fontSize: "1rem",
                },
              }}
            />
          </Grid>
        </>
      )}
    </>
  );
};

export default QuestionTypeSection;
